export interface IUserMgmt {
  id: string | null;
  group: number;
  name: string;
  email: string;
  phoneE164: string | null;
  isoRegionCode: string | null;
  role: string;
  mustChangePassword: boolean;
  /** EN-1883: end of the active period (UTC ISO with Z); null = forever. */
  expiresAtUtc: string | null;
  /** EN-1883: when the user was deactivated (UTC ISO with Z); null = not. */
  deactivatedAtUtc: string | null;
  /** EN-1883: computed by the server at response time. */
  isActive: boolean;
}

export class UserMgmt implements IUserMgmt {
  constructor(
    public id: string | null,
    public group: number,
    public name: string,
    public email: string,
    public phoneE164: string | null,
    public role: string,
    public mustChangePassword: boolean = false,
    public isoRegionCode: string | null = null,
    public expiresAtUtc: string | null = null,
    public deactivatedAtUtc: string | null = null,
    public isActive: boolean = true
  ) {}
}

/**
 * EN-1883: builds a UserMgmt from a user object returned by the API. Payloads
 * from before EN-1883 (no expiry fields) read as a forever, active user.
 * `group` overrides the payload's group (GET /admin/user/{groupId} rows).
 */
export function userMgmtFromApi(data: any, group?: number): UserMgmt {
  return new UserMgmt(
    data.id,
    group !== undefined ? group : data.group,
    data.name,
    data.email,
    data.phoneE164 || null,
    data.role,
    data.mustChangePassword === true,
    data.isoRegionCode || null,
    typeof data.expiresAtUtc === 'string' ? data.expiresAtUtc : null,
    typeof data.deactivatedAtUtc === 'string' ? data.deactivatedAtUtc : null,
    data.isActive !== false
  );
}

export interface ProvisionedUserResult {
  user: UserMgmt;
  temporaryPassword: string;
}
